module.exports = __webpack_public_path__ + "img/axis-realty-group-banner-4.e03a714b.jpg";